import React, { useState, useEffect, useRef } from 'react';
import { useLanguage } from '../context/LanguageContext';
import './Experience.css';

// Import images from src/images folder
import exp1 from '../images/experience/exp1.jpeg';
import exp2 from '../images/experience/exp2.jpeg';
import exp3 from '../images/experience/exp33.jpeg';
import exp4 from '../images/experience/exp4.jpeg';
import exp5 from '../images/experience/exp5.jpeg';
import exp6 from '../images/experience/exp6.jpeg';
import exp7 from '../images/experience/exp7.jpeg';
import exp8 from '../images/experience/exp8.jpeg';
import exp9 from '../images/experience/exp9.jpeg';
import exp10 from '../images/experience/exp10.jpeg';
import exp11 from '../images/experience/exp11.jpeg';
import exp12 from '../images/experience/exp12.jpeg';
import exp13 from '../images/experience/exp13.jpeg';
import exp14 from '../images/experience/exp14.jpeg';
import exp15 from '../images/experience/exp15.jpeg';
import exp16 from '../images/experience/exp16.jpeg';
import exp17 from '../images/experience/exp17.jpeg';
import exp18 from '../images/experience/exp18.jpeg';
import exp19 from '../images/experience/exp19.jpeg';
import exp20 from '../images/experience/exp20.jpeg';
import exp21 from '../images/experience/exp21.jpeg';

const Experience = () => {
  const { t, isRTL } = useLanguage();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const intervalRef = useRef(null);

  // Experience images - add more imports above and include them here
  const experienceImages = [
    { src: exp1, alt: 'Experience 1' },
    { src: exp2, alt: 'Experience 2' },
    { src: exp3, alt: 'Experience 3' },
    { src: exp4, alt: 'Experience 4' },
    { src: exp5, alt: 'Experience 5' },
    { src: exp6, alt: 'Experience 6' },
    { src: exp7, alt: 'Experience 7' },
    { src: exp8, alt: 'Experience 8' },
    { src: exp9, alt: 'Experience 9' },
    { src: exp10, alt: 'Experience 10' },
    { src: exp11, alt: 'Experience 11' },
    { src: exp12, alt: 'Experience 12' },
    { src: exp13, alt: 'Experience 13' },
    { src: exp14, alt: 'Experience 14' },
    { src: exp15, alt: 'Experience 15' },
    { src: exp16, alt: 'Experience 16' },
    { src: exp17, alt: 'Experience 17' },
    { src: exp18, alt: 'Experience 18' },
    { src: exp19, alt: 'Experience 19' },
    { src: exp20, alt: 'Experience 20' },
    { src: exp21, alt: 'Experience 21' },
  ];

  // Auto-slide functionality
  useEffect(() => {
    if (!isPaused) {
      intervalRef.current = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % experienceImages.length);
      }, 3000); // Change slide every 3 seconds
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [isPaused, experienceImages.length]);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % experienceImages.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + experienceImages.length) % experienceImages.length);
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const handleMouseEnter = () => {
    setIsPaused(true);
  };

  const handleMouseLeave = () => {
    setIsPaused(false);
  };

  return (
    <>
      <div style={{ clear: 'both' }} />
      <div className="sora-about-box" id="section-8">
        <div className="about-wrap row">
          <div className="about-title">
            <h4>
              <span style={{ color: '#ffbd2f' }}>{t.experience.name}</span>
            </h4>
            <p>{t.experience.subtitle}</p>
          </div>
          <div style={{ clear: 'both' }} />

          <div
            className={`experience-slider ${isRTL ? 'rtl' : ''}`}
            style={{ direction: 'ltr', flexDirection: 'row' }}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <button className="exp-slider-arrow prev" onClick={prevSlide}>
              <i className="fa fa-chevron-left" />
            </button>

            <div className="experience-slider-container">
              {experienceImages.map((image, index) => (
                <div
                  key={index}
                  className={`experience-slide ${index === currentIndex ? 'active' : ''}`}
                  style={{ display: index === currentIndex ? 'block' : 'none' }}
                >
                  <img src={image.src} alt={image.alt} />
                </div>
              ))}
            </div>

            <button className="exp-slider-arrow next" onClick={nextSlide}>
              <i className="fa fa-chevron-right" />
            </button>
          </div>

          <div className="experience-dots">
            {experienceImages.map((_, index) => (
              <button
                key={index}
                className={`exp-dot ${index === currentIndex ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Experience;
